// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27white%27 height=%2720%27 viewBox=%270 0 24 24%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfferingsDashboardPage {
  width: 100%;
  min-height: 100vh;
  color: #ffffff;
}

.off-db-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Middle Content Grid */
.off-db-grid {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 32px;
  width: 100%;
  box-sizing: border-box;
}

.off-db-main-flow {
  display: flex;
  flex-direction: column;
  gap: 20px;
}


.off-db-btn-primary {
  background-color: #3bb3ae;
  border: none;
  border-radius: 20px;
  color: #071414;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 20px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.off-db-btn-primary:hover {
  opacity: 0.9;
  box-shadow: 0 4px 12px rgba(59, 179, 174, 0.3);
}

/* Search and Filters */
.off-db-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 16px;
}

.off-db-search-wrap {
  width: 100%;
}

.off-db-search-input {
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: #ffffff;
  padding: 10px 16px;
  font-size: 14px;
  width: 100%;
  outline: none;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.off-db-search-input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.off-db-search-input:focus {
  border-color: rgba(72, 209, 204, 0.5);
  background-color: rgba(255, 255, 255, 0.06);
}

.off-db-filter-sort-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.off-db-tabs {
  display: flex;
  background-color: rgba(255, 255, 255, 0.03);
  padding: 4px;
  border-radius: 8px;
}

.off-db-tab-btn {
  background: transparent;
  border: none;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 16px;
  transition: all 0.2s ease;
}

.off-db-tab-btn:hover {
  color: #ffffff;
}

.off-db-tab-btn.active {
  background-color: rgba(72, 209, 204, 0.12);
  color: #48d1cc;
  font-weight: 700;
}

.off-db-sort-dropdown {
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  outline: none;
  padding: 6px 32px 6px 12px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
}

.off-db-sort-dropdown option {
  background-color: #0e1b1b;
  color: #fff;
}

/* Listings list */
.off-db-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Cards styling */
.off-card {
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 18px;
  padding: 16px;
  display: flex;
  gap: 20px;
  transition: all 0.25s ease;
  cursor: pointer;
}

.off-card:hover {
  border-color: rgba(72, 209, 204, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.off-card__image-container {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
}

.off-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.off-card__status-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 9px;
  font-weight: 800;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 10px;
  letter-spacing: 0.5px;
  backdrop-filter: blur(4px);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.off-card__status-badge--active {
  background-color: rgba(46, 117, 89, 0.75);
}

.off-card__status-badge--draft {
  background-color: rgba(120, 120, 120, 0.75);
}

.off-card__details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.off-card__meta-top {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
}

.off-card__category {
  color: #48d1cc;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.off-card__date {
  color: rgba(255, 255, 255, 0.4);
}

.off-card__title {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 4px 0 6px 0;
  cursor: pointer;
  transition: color 0.2s;
}

.off-card__title:hover {
  color: #48d1cc;
}

.off-card__description {
  font-size: 13.5px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 10px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.off-card__pricing {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

.off-card__actions {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  padding-left: 20px;
  width: 130px;
  flex-shrink: 0;
}

.off-card__toggle-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.off-card__toggle-label {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.45);
  text-transform: uppercase;
}

/* Toggle Switch */
.off-card__switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 20px;
}

.off-card__switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.off-card__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: .3s;
  border-radius: 34px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.off-card__slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: #fff;
  transition: .3s;
  border-radius: 50%;
}

input:checked+.off-card__slider {
  background-color: rgba(72, 209, 204, 0.2);
  border-color: rgba(72, 209, 204, 0.4);
}

input:checked+.off-card__slider:before {
  transform: translateX(18px);
  background-color: #48d1cc;
}

.off-card__btn-group {
  display: flex;
  gap: 8px;
}

.off-card__btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 600;
  padding: 6px 14px;
  transition: all 0.2s ease;
}

.off-card__btn--edit:hover {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.3);
  color: #fff;
}

.off-card__btn--delete:hover {
  background-color: rgba(179, 43, 43, 0.1);
  border-color: #b32b2b;
  color: #ff6b6b;
}

/* Right Column Widget section */
.off-db-widget-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.off-widget {
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 18px;
  padding: 20px;
  box-sizing: border-box;
}

.off-widget__title {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 800;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-left: 3px solid #48d1cc;
  padding-left: 8px;
}

.off-widget__stats-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.off-stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.02);
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.off-stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}

.off-stat-value {
  font-size: 15px;
  font-weight: 700;
}

.off-stat-value--active {
  color: #2e7559;
}

.off-stat-value--draft {
  color: rgba(255, 255, 255, 0.5);
}

.off-widget__list {
  padding-left: 18px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.off-widget__list li {
  font-size: 12.5px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.65);
}

/* Toast notifier styles */
.off-db-toast {
  position: fixed;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #0e1b1b;
  border: 1.5px solid #48d1cc;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 30px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 8px;
}

.off-db-toast span {
  color: #48d1cc;
  font-weight: 800;
}

.off-db-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: rgba(255, 255, 255, 0.5);
}

.off-db-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(72, 209, 204, 0.1);
  border-top-color: #48d1cc;
  border-radius: 50%;
  animation: spinner-spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes spinner-spin {
  to {
    transform: rotate(360deg);
  }
}

.off-db-empty {
  text-align: center;
  padding: 48px;
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 18px;
}

.off-db-empty__icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.off-db-empty h3 {
  font-size: 18px;
  margin-bottom: 8px;
}

.off-db-empty p {
  color: rgba(255, 255, 255, 0.55);
  font-size: 13.5px;
  margin-bottom: 20px;
}

/* Animations */
.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

.animate-slide-in {
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -10px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

/* Responsive constraints */
@media (max-width: 1024px) {
  .off-db-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .off-card {
    flex-direction: column;
  }

  .off-card__image-container {
    width: 100%;
    height: 160px;
  }

  .off-card__actions {
    flex-direction: row;
    width: 100%;
    align-items: center;
    border-left: none;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    padding-left: 0;
    padding-top: 12px;
    margin-top: 12px;
  }
}

/* Stock warning badges */
.off-card__stock-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 10px;
  letter-spacing: 0.5px;
  backdrop-filter: blur(4px);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 10;
}

.off-card__stock-badge--low {
  background-color: rgba(219, 137, 28, 0.85); /* Warm golden orange */
  border-color: rgba(219, 137, 28, 0.4);
}

.off-card__stock-badge--out {
  background-color: rgba(220, 53, 69, 0.85); /* Vivid red */
  border-color: rgba(220, 53, 69, 0.4);
}`, "",{"version":3,"sources":["webpack://./src/Pages/OfferingsDashboardPage/OfferingsDashboardPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,yDAAsN;EACtN,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,gDAAgD;EAChD,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,wCAAwC;AAC1C;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,+CAA+C;IAC/C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;EACX,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,0CAA0C,EAAE,uBAAuB;EACnE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC,EAAE,cAAc;EACzD,oCAAoC;AACtC","sourcesContent":[".OfferingsDashboardPage {\n  width: 100%;\n  min-height: 100vh;\n  color: #ffffff;\n}\n\n.off-db-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Middle Content Grid */\n.off-db-grid {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 32px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.off-db-main-flow {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n\n.off-db-btn-primary {\n  background-color: #3bb3ae;\n  border: none;\n  border-radius: 20px;\n  color: #071414;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 10px 20px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.off-db-btn-primary:hover {\n  opacity: 0.9;\n  box-shadow: 0 4px 12px rgba(59, 179, 174, 0.3);\n}\n\n/* Search and Filters */\n.off-db-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 16px;\n  padding: 16px;\n}\n\n.off-db-search-wrap {\n  width: 100%;\n}\n\n.off-db-search-input {\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  color: #ffffff;\n  padding: 10px 16px;\n  font-size: 14px;\n  width: 100%;\n  outline: none;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.off-db-search-input::placeholder {\n  color: rgba(255, 255, 255, 0.35);\n}\n\n.off-db-search-input:focus {\n  border-color: rgba(72, 209, 204, 0.5);\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\n.off-db-filter-sort-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.off-db-tabs {\n  display: flex;\n  background-color: rgba(255, 255, 255, 0.03);\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.off-db-tab-btn {\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: rgba(255, 255, 255, 0.6);\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 6px 16px;\n  transition: all 0.2s ease;\n}\n\n.off-db-tab-btn:hover {\n  color: #ffffff;\n}\n\n.off-db-tab-btn.active {\n  background-color: rgba(72, 209, 204, 0.12);\n  color: #48d1cc;\n  font-weight: 700;\n}\n\n.off-db-sort-dropdown {\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  outline: none;\n  padding: 6px 32px 6px 12px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='white' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n}\n\n.off-db-sort-dropdown option {\n  background-color: #0e1b1b;\n  color: #fff;\n}\n\n/* Listings list */\n.off-db-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Cards styling */\n.off-card {\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 18px;\n  padding: 16px;\n  display: flex;\n  gap: 20px;\n  transition: all 0.25s ease;\n  cursor: pointer;\n}\n\n.off-card:hover {\n  border-color: rgba(72, 209, 204, 0.25);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n}\n\n.off-card__image-container {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  border-radius: 12px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.off-card__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.off-card__status-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  font-size: 9px;\n  font-weight: 800;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 10px;\n  letter-spacing: 0.5px;\n  backdrop-filter: blur(4px);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.off-card__status-badge--active {\n  background-color: rgba(46, 117, 89, 0.75);\n}\n\n.off-card__status-badge--draft {\n  background-color: rgba(120, 120, 120, 0.75);\n}\n\n.off-card__details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.off-card__meta-top {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n}\n\n.off-card__category {\n  color: #48d1cc;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.off-card__date {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.off-card__title {\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 4px 0 6px 0;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.off-card__title:hover {\n  color: #48d1cc;\n}\n\n.off-card__description {\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0 0 10px 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.off-card__pricing {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.off-card__actions {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  border-left: 1px solid rgba(255, 255, 255, 0.05);\n  padding-left: 20px;\n  width: 130px;\n  flex-shrink: 0;\n}\n\n.off-card__toggle-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.off-card__toggle-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.45);\n  text-transform: uppercase;\n}\n\n/* Toggle Switch */\n.off-card__switch {\n  position: relative;\n  display: inline-block;\n  width: 38px;\n  height: 20px;\n}\n\n.off-card__switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.off-card__slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.1);\n  transition: .3s;\n  border-radius: 34px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.off-card__slider:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 2px;\n  bottom: 2px;\n  background-color: #fff;\n  transition: .3s;\n  border-radius: 50%;\n}\n\ninput:checked+.off-card__slider {\n  background-color: rgba(72, 209, 204, 0.2);\n  border-color: rgba(72, 209, 204, 0.4);\n}\n\ninput:checked+.off-card__slider:before {\n  transform: translateX(18px);\n  background-color: #48d1cc;\n}\n\n.off-card__btn-group {\n  display: flex;\n  gap: 8px;\n}\n\n.off-card__btn {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 6px 14px;\n  transition: all 0.2s ease;\n}\n\n.off-card__btn--edit:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #fff;\n}\n\n.off-card__btn--delete:hover {\n  background-color: rgba(179, 43, 43, 0.1);\n  border-color: #b32b2b;\n  color: #ff6b6b;\n}\n\n/* Right Column Widget section */\n.off-db-widget-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.off-widget {\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 18px;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.off-widget__title {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 800;\n  color: #ffffff;\n  margin-top: 0;\n  margin-bottom: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-left: 3px solid #48d1cc;\n  padding-left: 8px;\n}\n\n.off-widget__stats-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.off-stat-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.02);\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.off-stat-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.off-stat-value {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.off-stat-value--active {\n  color: #2e7559;\n}\n\n.off-stat-value--draft {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.off-widget__list {\n  padding-left: 18px;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.off-widget__list li {\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.65);\n}\n\n/* Toast notifier styles */\n.off-db-toast {\n  position: fixed;\n  top: 90px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #0e1b1b;\n  border: 1.5px solid #48d1cc;\n  color: #ffffff;\n  padding: 12px 24px;\n  border-radius: 30px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.off-db-toast span {\n  color: #48d1cc;\n  font-weight: 800;\n}\n\n.off-db-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 0;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.off-db-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid rgba(72, 209, 204, 0.1);\n  border-top-color: #48d1cc;\n  border-radius: 50%;\n  animation: spinner-spin 0.8s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes spinner-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.off-db-empty {\n  text-align: center;\n  padding: 48px;\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px dashed rgba(255, 255, 255, 0.1);\n  border-radius: 18px;\n}\n\n.off-db-empty__icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.off-db-empty h3 {\n  font-size: 18px;\n  margin-bottom: 8px;\n}\n\n.off-db-empty p {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 13.5px;\n  margin-bottom: 20px;\n}\n\n/* Animations */\n.animate-fade-in {\n  animation: fadeIn 0.3s ease-out forwards;\n}\n\n.animate-slide-in {\n  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n/* Responsive constraints */\n@media (max-width: 1024px) {\n  .off-db-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .off-card {\n    flex-direction: column;\n  }\n\n  .off-card__image-container {\n    width: 100%;\n    height: 160px;\n  }\n\n  .off-card__actions {\n    flex-direction: row;\n    width: 100%;\n    align-items: center;\n    border-left: none;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    padding-left: 0;\n    padding-top: 12px;\n    margin-top: 12px;\n  }\n}\n\n/* Stock warning badges */\n.off-card__stock-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 10px;\n  letter-spacing: 0.5px;\n  backdrop-filter: blur(4px);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  z-index: 10;\n}\n\n.off-card__stock-badge--low {\n  background-color: rgba(219, 137, 28, 0.85); /* Warm golden orange */\n  border-color: rgba(219, 137, 28, 0.4);\n}\n\n.off-card__stock-badge--out {\n  background-color: rgba(220, 53, 69, 0.85); /* Vivid red */\n  border-color: rgba(220, 53, 69, 0.4);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
